import { useLocation } from 'react-router-dom';
import { LANGUAGE, LANGUAGES, languagePath } from '../i18n';

export default function LanguageSwitcher() {
  const { pathname, search, hash } = useLocation();
  const labels = { it: 'Italiano', de: 'Deutsch', fr: 'Français' };
  return <nav className="language-switcher" aria-label={{it:'Lingua',de:'Sprache',fr:'Langue'}[LANGUAGE]}>
    {LANGUAGES.map(language => <a key={language} href={languagePath(pathname, language) + search + hash} hrefLang={language + '-CH'} lang={language} aria-label={labels[language]} aria-current={language === LANGUAGE ? 'true' : undefined}>{language.toUpperCase()}</a>)}
  </nav>;
}
